import React from 'react';
import { Card, Result } from 'antd';
import { useLocation } from 'react-router-dom';
import { getReportByRoute } from '@/reports/registry/standardReports';
import { ReportRunner } from '@/reports/components/ReportRunner';
import { useAuthStore } from '@/store/authStore';

/**
 * Route-driven report runner: resolves ReportDefinition from the current path.
 */
export const ReportRunnerPage: React.FC = () => {
  const location = useLocation();
  const user = useAuthStore((s) => s.user);
  const definition = getReportByRoute(location.pathname);

  if (!definition) {
    return <Result status="404" title="Report not found" subTitle={location.pathname} />;
  }

  const allowed =
    user?.is_super_admin ||
    !definition.permissionCodes.length ||
    definition.permissionCodes.some((c) => user?.permissions?.includes(c));

  if (!allowed) {
    return (
      <Card>
        <Result status="403" title="Access denied" subTitle="Missing report permission" />
      </Card>
    );
  }

  return <ReportRunner definition={definition} />;
};

export default ReportRunnerPage;
